import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'databricks',
  name: 'Databricks',
  category: 'database',
  description: 'Execute SQL queries on Databricks using the SQL Statement Execution API. Connect to your data lakehouse to query, analyze, and transform data.',
  icon: 'siDatabricks',
  iconType: 'simple-icon',
  color: 'red',
  version: '1.0.0',
  group: ['transform'],
  defaults: {
    name: 'Databricks',
    color: '#FF3621',
  },
  credentials: [
    {
      name: 'databricks',
      required: true,
      displayName: 'Databricks',
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['databricks', 'sql', 'spark', 'data', 'analytics', 'lakehouse', 'azure', 'aws', 'delta'],
  comingSoon: false,

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'databricks_sql',
    description: 'Execute SQL queries on Databricks. Supports SELECT, INSERT, UPDATE, DELETE, and DDL statements via the SQL Statement Execution API.',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The operation to perform: executeQuery (run SQL), getStatementStatus (check async query status), cancelStatement (cancel running query)',
        required: true,
        type: 'string',
      },
      warehouseId: {
        toolParamName: 'warehouse_id',
        description: 'The SQL warehouse ID to execute the query against',
        required: true,
        type: 'string',
      },
      statement: {
        toolParamName: 'statement',
        description: 'The SQL statement to execute',
        required: false,
        type: 'string',
      },
      statementId: {
        toolParamName: 'statement_id',
        description: 'The statement ID (for status check or cancellation)',
        required: false,
        type: 'string',
      },
      waitTimeout: {
        toolParamName: 'wait_timeout',
        description: 'Timeout for synchronous execution (e.g., "30s", "5m")',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      statement_id: 'Unique identifier for the statement execution',
      status: 'Current status of the statement (PENDING, RUNNING, SUCCEEDED, FAILED, etc.)',
      manifest: 'Schema information including columns and data types',
      result: 'Query result data as an array',
      row_count: 'Number of rows returned',
    },
  },
};

export default definition;
